module.exports = __webpack_public_path__ + "static/media/SC.ab3ba4fa.jpg";